module.exports = __webpack_public_path__ + "img/2f7f9d24f2c443e99d5a9dd4e78e185b.03d7739e.png";